/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import ServicesLayout from '../../../components/ServicesLayout';
import ResetPassword from './ResetPassword';

const title = 'Resetowanie hasła';

export default {
  path: '/resetPassword',

  action() {
    return {
      title,
      component: <ServicesLayout><ResetPassword title={title} /></ServicesLayout>,
    };
  },
};



// WEBPACK FOOTER //
// src/routes/login/resetPassword/index.js